import React from "react"
import styled from "styled-components"
import { StandardContainer, StyledHeading } from "../common"

const StyledBlogHeader = styled(StandardContainer)`
  margin-top: 180px;
  margin-bottom: 60px;
  &:after {
    content: "";
    width: 200px;
    height: 5px;
    background: ${(props) => props.color || props.theme.color.brandColor};
    display: block;
  }
`

export const BlogHeader = ({ title, category }) => {
  const { category_color, title: categoryTitle } =
    (category?.document && category?.document?.data) || {}
  return (
    <StyledBlogHeader padH $wrappedStandard color={category_color}>
      {categoryTitle && (
        <StyledHeading color="#005d73" ttu>
          {categoryTitle?.text}
        </StyledHeading>
      )}
      <StyledHeading as="h1" size="h1" color="#005d73">
        {title?.text}
      </StyledHeading>
    </StyledBlogHeader>
  )
}
